import styled from 'styled-components'

import { Button } from '@syconium/little-miss-figgy'

export const PlacementForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(5)};
`

export const AddButton = styled(Button)`
  width: 100%;
`
